import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import { LanguageProvider } from "@/contexts/LanguageContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import Index from "./pages/Index";

// Lazy load route pages to reduce initial bundle size
const About = lazy(() => import("./pages/About"));
const PaymentPolicy = lazy(() => import("./pages/PaymentPolicy"));
const ForMembersOnly = lazy(() => import("./pages/ForMembersOnly"));
const PlumbingService = lazy(() => import("./pages/services/PlumbingService"));
const CleaningService = lazy(() => import("./pages/services/CleaningService"));
const MovingService = lazy(() => import("./pages/services/MovingService"));
const HandymanService = lazy(() => import("./pages/services/HandymanService"));
const RenovationService = lazy(() => import("./pages/services/RenovationService"));
const GardenService = lazy(() => import("./pages/services/GardenService"));
const HVACService = lazy(() => import("./pages/services/HVACService"));
const NotFound = lazy(() => import("./pages/NotFound"));

const queryClient = new QueryClient();

const App = () => (
  <ErrorBoundary>
    <QueryClientProvider client={queryClient}>
      <LanguageProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/about" element={<About />} />
                <Route path="/payment-policy" element={<PaymentPolicy />} />
                <Route path="/members" element={<ForMembersOnly />} />
                <Route path="/services/plumbing" element={<PlumbingService />} />
                <Route path="/services/cleaning" element={<CleaningService />} />
                <Route path="/services/moving" element={<MovingService />} />
                <Route path="/services/handyman" element={<HandymanService />} />
                <Route path="/services/renovation" element={<RenovationService />} />
                <Route path="/services/garden" element={<GardenService />} />
                <Route path="/services/hvac" element={<HVACService />} />
                {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Suspense>
          </BrowserRouter>
        </TooltipProvider>
      </LanguageProvider>
    </QueryClientProvider>
  </ErrorBoundary>
);

export default App;
